import styled from '@emotion/styled';

export const NoRecord = styled.p`
  text-align: center;
  font-size: 3rem;
  margin: 10rem auto;
  color: var(--primary-color9);
`;

export const ComeBackLater = styled.div`
  font-size: 3rem;
  min-height: 25vh;
  color: var(--primary-color9);
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 3em 0;
  width: 100%;
`;

export const EllipsisTextBox = styled.div`
  line-height: 3rem;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  height: 120px;
`;

export const SocialBoxContainer = styled.div`
  @media (max-width: 400px) {
    position: relative !important;
    width: 100% !important;

    ul {
      display: flex !important;
      justify-content: flex-start !important;
      margin-bottom: 2.5rem;
    }
  }
`;

export const SocialBox = styled.ul`
  height: fit-content;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 1.5rem;

  li {
    margin-bottom: 1.2rem !important;
  }
`;

export const InfoBox = styled.div`
  display: flex;
  color: var(--primary-color6);
  font-size: 2rem;
  margin-bottom: 2rem;
  line-height: 32px;
  overflow: hidden;

  span {
    font-weight: bold;
  }

  a {
    overflow: hidden;
    text-overflow: ellipsis;
    color: var(--primary-color6);
    :hover {
      color: var(--primary-color3);
    }
  }
`;

export const HistoryTable = styled.table`
  line-height: 2.5rem;
  white-space: nowrap;
  min-width: 100rem;

  thead {
    color: var(--primary-color2);
  }

  th {
    border: 0 !important;
  }

  tbody {
    color: var(--primary-color4);
    max-height: 500px;
  }
`;

export const Blur = styled.div`
  backdrop-filter: blur(5px);
  padding: 20px;
`;

export const IconButton = styled.button`
  height: 40px;
  width: 40px;
  background-color: var(--primary-color3);
  color: #fff;
  padding: 0 0;
  border-radius: 8px;
  text-align: center;
  justify-content: center;
  align-items: center;
  display: flex;
  font-size: 24px;

  :hover,
  :active,
  :focus,
  :focus-visible {
    background-color: var(--primary-color3);
    color: #fff;
  }
`;
